import styled, { css } from "styled-components";

interface IWithState {
  state: "available" | "occupied" | "maintenance" | "reserved";
}

export const Container = styled.div``;
export const StateContainer = styled.div`
  margin-bottom: 0.5rem;
`;
export const Flag = styled.img<IWithState>`
  position: absolute;
  top: 0;
  left: 3rem;
  ${({ state }) =>
    state === "reserved" &&
    css`
      left: 1rem;
    `}
`;
export const State = styled.p<IWithState>`
  color: var(--reserved-hu);
  ${({ state }) =>
    state !== "reserved" &&
    css`
      display: none;
    `}
`;
export const ReservesContainer = styled.div``;
